import { Button } from '../../components/ui';
import { requestAlertPermission, setSoundOn, usePermission, useSoundOn } from './desktopAlerts';

/**
 * "Turn on desktop alerts" (D6). The only place the browser is ever asked for
 * permission; nothing asks on load. Four states:
 * - default: the button;
 * - granted: "Desktop alerts on";
 * - denied: one line on how to unblock it in the browser;
 * - unsupported (an old browser, or a phone browser with no Notification):
 *   nothing at all.
 */
export function DesktopAlertsButton({ compact = false }: { compact?: boolean }) {
  const permission = usePermission();
  if (permission === 'unsupported') {
    return null;
  }
  if (permission === 'granted') {
    return <p className="messages-alerts-state">Desktop alerts on</p>;
  }
  if (permission === 'denied') {
    return (
      <p className="messages-alerts-state messages-alerts-state--blocked">
        Desktop alerts are blocked. Click the lock or site icon next to the address, allow
        Notifications, then reload.
      </p>
    );
  }
  return (
    <Button
      size="sm"
      variant={compact ? 'ghost' : 'secondary'}
      onClick={() => {
        void requestAlertPermission();
      }}
    >
      Turn on desktop alerts
    </Button>
  );
}

/** The sound switch for Settings (D5). Per device, on by default. */
export function MessageSoundSwitch() {
  const on = useSoundOn();
  return (
    <label className="settings-switch">
      <input
        type="checkbox"
        checked={on}
        aria-label="Play a sound for new messages"
        onChange={(changed) => setSoundOn(changed.target.checked)}
      />
    </label>
  );
}
